import { render, staticRenderFns } from "./ServiceAdminPage.vue?vue&type=template&id=6f438e61&scoped=true&"
import script from "./ServiceAdminPage.vue?vue&type=script&lang=ts&"
export * from "./ServiceAdminPage.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceAdminPage.vue?vue&type=style&index=0&id=6f438e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f438e61",
  null
  
)

export default component.exports